import { PageHeader } from "components";
import { NextPage } from "next";
import Head from "next/head";
import {
  DeliverySection,
  JetsonOneGallerySection,
  JetsonOneHeaderSection,
  JetsonOneSafetySection,
  MeetJetsonOneSection,
  TechSpecificationSection,
} from "sections";
import {
  IDeliverySectionFields,
  IGallerySectionFields,
  IStaticJetsonOneHeaderSectionFields,
  IStaticMeetJetsonOneSectionFields,
  IStaticSafetySectionFields,
  ITechSpecificationV3Fields,
} from "types";
import { getContentfulEntries } from "../utils/contentful-api";

const JetsonOne: NextPage<{
  techSpecification: ITechSpecificationV3Fields[];
  delivery: IDeliverySectionFields[];
  header: IStaticJetsonOneHeaderSectionFields[];
  meetJetson: IStaticMeetJetsonOneSectionFields[];
  safety: IStaticSafetySectionFields[];
  gallery: IGallerySectionFields[];
}> = ({ techSpecification, delivery, header, meetJetson, safety, gallery }) => {
  return (
    <div>
      <Head>
        <title>Jetson ONE | Jetson - Personal Electric Aerial Vehicle</title>
        <PageHeader
          ogImage="https://www.jetson.com/assets/images/jetsonone-cover.jpeg"
          title="Jetson ONE"
        />
      </Head>
      <JetsonOneHeaderSection headerSection={header} />
      <MeetJetsonOneSection meetJetsoOneSection={meetJetson} />
      <JetsonOneSafetySection safetySection={safety} />
      <TechSpecificationSection techSpecification={techSpecification} />
      <JetsonOneGallerySection gallerySection={gallery} />
      <DeliverySection deliverySection={delivery} />
    </div>
  );
};
export default JetsonOne;

export async function getStaticProps() {
  const techSpecification =
    await getContentfulEntries<ITechSpecificationV3Fields>(
      "techSpecificationV3",
      "sys.createdAt"
    );

  const delivery = await getContentfulEntries<IDeliverySectionFields>(
    "deliverySection"
  );

  const header =
    await getContentfulEntries<IStaticJetsonOneHeaderSectionFields>(
      "jetsonOneHeaderSection"
    );

  const meetJetson =
    await getContentfulEntries<IStaticMeetJetsonOneSectionFields>(
      "meetJetsonOneSection"
    );

  const safety = await getContentfulEntries<IStaticSafetySectionFields>(
    "safetySection"
  );

  const gallery = await getContentfulEntries<IGallerySectionFields>(
    "gallerySection"
  );

  return {
    props: {
      techSpecification,
      delivery,
      header,
      meetJetson,
      safety,
      gallery,
    },
    revalidate: 3600, // Revalidate every hour
  };
}
